import { WhatsappTemplateButtonTypeEnum } from 'src/app/parameters/message-templates/whatsapp-templates/shared/models/whatsapp-template-button-type.enum';
import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function WhatsappTemplateBoxViewConstructor(services, callbacks, context) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    isElementEditable: true,
    editElementModalController: 'editWhatsappTemplateBoxController',
    editElementModalTemplate: require('./editWhatsappTemplateBox.modal.html'),
    angularTemplate: require('./whatsapp-template-box-view.html'),

    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      setTimeout(() => this.updateValidity(), 200);
    },

    afterEditElement: function (oldElementData, newElementData) {
      if (this.shouldUpdateExits(this.model.get('elementData'), newElementData)) {
        const children = this.model.getEmbeddedCells();
        const userInputChild = children.find(child => child.get('type') === 'html.UserInput');
        this.model.unembed(userInputChild);
        children.filter(child => child.get('type') !== 'html.UserInput')
          .forEach(child => child.remove());
        const newButtons = newElementData.template.buttons;
        const buttonsWithoutCopyCodeType = (newButtons || []).filter(({ type }) => type !== WhatsappTemplateButtonTypeEnum.COPY_CODE);
        if (buttonsWithoutCopyCodeType && buttonsWithoutCopyCodeType.length > 0) {
          services.QuickRepliesFactory.createUniqueIds(context.companyId, context.site.id, context.scenarioId, buttonsWithoutCopyCodeType.length)
            .then(response => {
              this.addExits(buttonsWithoutCopyCodeType, response.data.map(element => element.id));
              this.model.embed(userInputChild);
              callbacks.updateSerializedGraph(this.model.graph);
            },
              services.AlertingFactory.httpErrorHandler());
        } else {
          this.model.embed(userInputChild);
        }
      }
      this.model.set('elementData', this.angularScope.elementData);
      setTimeout(() => this.updateValidity());
    },


    shouldUpdateExits(oldElementData, newElementData) {
      // update exits iff there was no template selected before, or if we now use a different template
      return !oldElementData || !oldElementData.template || (oldElementData.template.id !== newElementData.template.id);
    },

    updateValidity: function () {
      if (!this.angularScope.elementData) {
        this.model.setBoxValid(false);
      } else {
        this.model.setBoxValid(!!this.angularScope.elementData.template);
      }
    },


    addExits: function (buttons, ids) {
      buttons
        .filter(({ type }) => type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY)
        .forEach(({ text }, index) => {
          let buttonElementData;
          buttonElementData = {
            index: index,
            label: text
          };
          const exit = this.createExit(ids[index], TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE, buttonElementData);
          this.model.graph.addCell(exit);
        });

    },


    createExit: function (id, position, size, elementData) {
      const exit = new joint.shapes.html.WhatsappTemplateExit({ id, position, size, elementData });
      this.model.embed(exit);
      return exit;
    },

  });
}
